import Numeral from "numeral";
import {isWhiteSpace} from "./utils";

export class NumberHelper {
    static formatNumber(value: any) {
        if (value == null || value === '' || isWhiteSpace(value) || isNaN(value))
            return value;

        const number = Number(value);
        const formatted = Numeral(number).format(`0[.][000000000000000]`);
        return formatted;
    }

    static parseNumber(value: number | string, numberGroupSeparator: string, numberDecimalSeparator: string) {
        if (typeof value === "number")
            return value;

        const number = value
            .replace(new RegExp('\\' + numberGroupSeparator, 'g'), '')
            .replace(new RegExp('\\' + numberDecimalSeparator, 'g'), '.');
        return Number(number);
    }
}

export default NumberHelper;